"use strict";

/**
* Элемент списка объектов.
*
* @class WebAccess.components.wrappers.objectList.ListItem
* @since 5.0.0.4102
* @extends BasePageElement
* @property {string} id ИД объекта
* @property {string} name Имя объекта
* @property {string} kind Тип объекта. Например, задача, задание, документ
* @param {string} itemSelector Существующий элемент списка
* @param {boolean} isTableItem Признак того, что текущий элемент является строкой таблицы
*/
(function (global) {

  var ListItem = WebAccess.components.wrappers.BasePageElement.extend([global.mixins.linkMixin], {
    init: function (itemSelector, isTableItem, data) {
      let me = this;
      let clickElementSelector = isTableItem ? 'a' : '.object-list-item__title-span';

      me._super(itemSelector);
      me._jObject = $(itemSelector);

      if (!isTableItem) {
        me.id = me._jObject.attr('id');
        me.name = me._jObject.find(".objectname").text();

        me.kind = me._jObject.attr('kind').toUpperCase();

        if (me.kind !== 'VER') {
          me.type = objectKindToObjectType(me.kind);
        } else {
          clickElementSelector = '.doc-version__name';
        }
        me.referenceName = me.referenceCode = me._jObject.attr('compcode');
        me.isSelected = me._jObject.find('input:first').is(':checked');
      } else {
        $.extend(me, data);
      }

      me.click = () => me._jObject.find(clickElementSelector)[0].click();

      me._setupBindings();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    className: "ListItem",
    id: null,
    name: null,
    kind: null,
    type: null,
    referenceName: null,
    referenceCode: null,
    isSelected: false,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Установка событий. При щелчке на чекбокс, вызываем событие у всего списка, чтобы удобно было менять состояние кнопок тулбара например.
     * @private
     * @return {WebAccess.components.wrappers.objectList.ListItem}
     */
    _setupBindings() {
      let me = this;
      this._jObject
        .find('input.chk')
        .off('change.objectList itemChecked')
        .on('change.objectList itemChecked', function () {
          let jCheckboxObject = $(this);
          if (jCheckboxObject.is(':checked')) {
            global.current.objectList.fire('itemSelect', me);
          } else {
            global.current.objectList.fire('itemUnSelect', me);
          }
        });
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показать иконку связанных объектов.
    *
    * @method WebAccess.components.wrappers.objectList.ListItem#showBindIcon
    * @return {WebAccess.components.wrappers.objectList.ListItem} Объект класса ListItem.
    * @since 5.1.0.1523
    */
    showBindIcon: function () {
      this._jObject.find('.object-list-item__addicon_type_bound').show();

      return this;
    },

    /**
    * Скрыть элемент списка.
    * @method WebAccess.components.wrappers.objectList.ListItem#hide
    * @return {WebAccess.components.wrappers.objectList.ListItem} Объект класса ListItem.
    */
    hide: function () {
      this._jObject.hide();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показать элемент списка.
    *
    * @method WebAccess.components.wrappers.objectList.ListItem#show
    * @return {WebAccess.components.wrappers.objectList.ListItem} Объект класса ListItem.
    */
    show: function () {
      this._jObject.show();
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

  global.components.wrappers.objectList.ListItem = ListItem;
})(window.WebAccess);
